import {
  TOpenSourceLicense,
} from './table-open-source-licenses.ts';

const licenseColumn: Record<keyof TOpenSourceLicense, string> = {
  name: 'Library / Projekt',
  version: 'Version',
  license: 'Lizenz',
  url: 'Homepage',
  notice: 'Lizenztext',
  notice_url: 'Lizenz URL',
  package_url: 'URL im Paketindex',
};

export default {
  licenseColumn,
};
